<template>
  <div>
    <h2>To Dos</h2>
    <p>
      <b-link @click="handleGoToDocViewClick">
        {{ logDocsAll.length }} Documents </b-link
      >| {{ tasks.length }} Total | | {{ userDataTasksNeedsHelp.length }} Needs
      Help | {{ userDataTasksNotStarted.length }} Not Started |
      {{ userDataTasksStarted.length }} Started |
      {{ userDataTasksDone.length }} Done
    </p>
    <b-row>
      <b-col cols="4">
        <b-row>
          <b-col>
            <h3>Start Here</h3>
          </b-col>
        </b-row>
        <b-row class="task-column">
          <b-col>
            <draggable class="list-group"
                       :list="userDataTasksNeedsHelp"
                       group="people"
                       @change="log">
              <task-card
                  v-for="(aTask, index) in userDataTasksNeedsHelp"
                  class="list-group-item"
                  :task="aTask"
                  :key="`task_${index}`"
                  style="cursor:move;"
              />
            </draggable>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4">
        <b-row>
          <b-col>
            <h3>In Progress</h3>
          </b-col>
        </b-row>
        <b-row class="task-column">
          <b-col>
            <draggable class="list-group"
                       :list="tasksInProgress"
                       :empty-insert-threshhold="500"
                       group="people"
                       @change="log"
            >
              <task-card
                  v-for="(aTask, index) in tasksInProgress"
                  class="list-group-item"
                  :task="aTask"
                  :key="`task_${index}`"
                  style="cursor:move;"
              />
            </draggable>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4">
        <b-row>
          <b-col>
            <h3>Done</h3>
          </b-col>
        </b-row>
        <b-row class="task-column" >
          <b-col>
            <draggable class="list-group"
                       :list="tasksDone"
                       group="people"
                       @change="log">
              <task-card
                  v-for="(aTask, index) in tasksDone"
                  class="list-group-item"
                  :task="aTask"
                  :key="`task_${index}`"
                  style="cursor:move;"
              />
            </draggable>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <rawDisplayer class="col-3" :value="tasksDone" title="List 1" />
  </div>
</template>

<script>
import moment from "moment";
import TipTapOutput from "@/components/common/tipTapOutput";
import Draggable from "vuedraggable";
import TaskCard from "../taskCard";
export default {
  components: {
    TipTapOutput,
    TaskCard,
    Draggable
  },
  props: {
    resource: {
      type: Object,
      default: () => {},
      required: false
    },
    tasks: {
      type: Array,
      default: () => {
        return [];
      },
      required: true
    },
    logDocsAll: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  computed: {
    userDataTasksNeedsHelpOrNotStarted() {
      return (
          this.tasks &&
          Array.isArray(this.tasks) &&
          this.tasks.filter(aTask => {
            return aTask.status === "needs_help";
          })
      );
    },
    userDataTasksNeedsHelp() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "needs_help";
        })
      );
    },
    userDataTasksNotStarted() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "not_started";
        })
      );
    },
    userDataTasksStarted() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "started";
        })
      );
    },
    userDataTasksDone() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "done";
        })
      );
    }
  },
  methods: {
    getUserDataTasks(taskStatus) {
      return (
          this.tasks &&
          Array.isArray(this.tasks) &&
          this.tasks.filter(aTask => {
            return aTask.status === taskStatus;
          })
      );
    },
    add: function() {
      this.list.push({ name: "Juan" });
    },
    replace: function() {
      this.list = [{ name: "Edgard" }];
    },
    clone: function(el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function(evt) {
      window.console.log(evt);
    },
    formattedDate(date) {
      //@TODo - Date format should be standardized even for apps
      return moment(new Date(date.toDate())).format("dddd, DD MMMM YYYY");
    },
    /* EMITTERS */
    handleRowClicked(item) {
      this.$emit("log-row-clicked", item);
    },
    handleGoToDocViewClick() {
      this.$emit("go-to-docs-view");
    }
  },
  data() {
    return {
      tasksNotStarted: this.getUserDataTasks('needs_help'),
      tasksInProgress: this.getUserDataTasks('in_progress'),
      tasksDone: this.getUserDataTasks('done'),
      fields: [
        {
          key: "task",
          sortable: true,
          label: "Task"
        },
        {
          key: "note",
          sortable: true,
          label: "Notes"
        },
        {
          key: "_created_at",
          sortable: true,
          label: "Last Update"
        }
      ],
      tableVariants: [
        "primary",
        "secondary",
        "info",
        "danger",
        "warning",
        "success",
        "light",
        "dark"
      ],
      striped: true,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: true,
      headVariant: null,
      tableVariant: "",
      noCollapse: false
    };
  }
};
</script>


<style lang="scss" scoped>
.task-column {
  background-color: #8D99A0;
  height: 100vh;
  padding: 15px;
  border-radius:15px;
  margin:10px
}

</style>